export const SIDEBAR_IMAGES = {
  CARET: "caret_down.svg",
  HOME: "updates.svg",
  HOME_ON: "home_white.svg",
  HOME_OFF: "home_gray.svg",
  AI_ON: "ai_on.svg",
  AI_OFF: "ai_off.svg",
  SETTINGS_HEADER: "settings.png",
  SETTINGS_PERSONAL: "settings_sub.png",
  SETTINGS_WORKSPACES: "settings_sub.png",
  FAVORITES_ON: "favorites_selected.svg",
  FAVORITES_OFF: "favorite_off.svg",
  ALL_ON: "all_on.svg",
  ALL_OFF: "all_off.svg",
  ASKED_YOURS_ON: "your_questions_on.svg",
  ASKED_YOURS_OFF: "your_questions_off.svg",
  ASKED_ALL_ON: "all_questions_on.svg",
  ASKED_ALL_OFF: "all_questions_off.svg",
  MANAGE_ON: "manage_on.svg",
  MANAGE_OFF: "manage_off.svg",
  ASKED_ON: "clock_on.svg",
  ASKED_OFF: "clock_off.svg",
  COLLECTION_ASK_ON: "collection_ask_white.svg",
  COLLECTION_ASK_OFF: "collection_ask_gray.svg",
  COLLECTION_RESOURCES_ON: "manage_resources_white.svg",
  COLLECTION_RESOURCES_OFF: "manage_resources_gray.svg",
  COLLECTION_ASKED_ON: "recently_white.svg",
  COLLECTION_ASKED_OFF: "recently_gray.svg",
  COLLECTION_STATS_ON: "dashboard_white.svg",
  COLLECTION_STATS_OFF: "dashboard_gray.svg",
  SNIPPET_MANAGER_ON: "snippet_manager_white.svg",
  SNIPPET_MANAGER_OFF: "snippet_manager_gray.svg",
  COLLECTION_REPORT_CARD_ON: "report_card_on.svg",
  COLLECTION_REPORT_CARD_OFF: "report_card_off.svg",
  CONFIGURE_ON: "add_resources_white.svg",
  CONFIGURE_OFF: "add_resources_gray.svg",
  PERSONA_MANAGER_ON: "persona_manager_on.svg",
  PERSONA_MANAGER_OFF: "persona_manager_off.svg",
  POLICY_STUDIO_ON: "policy_studio_on.svg",
  POLICY_STUDIO_OFF: "policy_studio_off.svg",
};

export const IMG_AVATAR_UNKNOWN = "avatar_unknown.png";
export const IMG_CLOSE = "/icons/close.png";
export const IMG_LINK_BLACK = "/icons/link_horizontal.png";
export const IMG_LINK_WHITE = "/icons/link_horizontal_white.png";

export const IMG_DOWNLOAD = "/icons/download.png";

export const THREE_DOTS_IMAGES = {
  HORIZONTAL: "/icons/three_dots_horizontal.png",
  VERTICAL: "/icons/three_dots_vertical.png",
};

export const UPDATE_IMAGES = {
  ANNOTATIONS: "/icons/chat.svg",
  PLAY: "/icons/play_embed.svg",
};

export const MINICARD_IMAGES = {
  PLAY: "/icons/play_embed.svg",
};

export const ASSET_IMAGES = {
  UNDO: "/icons/undo.png",
  REDO: "/icons/redo.png",
  COMMENT: "/icons/comment.svg",
  ARROW: "/icons/arrow_down_left.svg",
  ARROW_BACK: "/icons/arrow_left.svg",
  SCREENSHOT: "/icons/screenshot.svg",
  MORE_REPLIES: "/icons/more_replies.svg",
  VIDEO_FORWARD: "/icons/video_forward.svg",
  VIDEO_BACKWARD: "/icons/video_backward.svg",
  PLAY: "/icons/play.svg",
  PAUSE: "/icons/light-mode/light_pause.svg",
  VOLUME: "/icons/volume.svg",
  TEN: "/icons/10.svg",
};

export const SCREENSHOT_IMAGES = {
  TRASH: "/icons/trash_white.svg",
  COPY: "/icons/copy_screenshot.svg",
  SAVE: "/icons/comment.svg",
  DOWNLOAD: "/icons/download_screenshot.svg",
  CLOSE: "/icons/close_white.svg",
};

export const LOGO_IMAGES = {
  JIRA: "/connection_logos/jira.svg",
  GITHUB: "/icons/github_logo.png",
};

export const CAPTURE_IMAGES = {
  MIC_ON: "/icons/mic_on.svg",
  MIC_OFF: "/icons/mic_off.svg",
  STOP: "/icons/stop.svg",
  PAUSE: "/icons/light-mode/light_pause.svg",
  PLAY: "/icons/light-mode/light_play.svg",
  TRASH: "/icons/trash.svg",
};

export const PLACEHOLDER_IMAGES = [
  "/placeholders/guest_comments.png",
  "/placeholders/jira_integration.png",
  "/placeholders/keyboard_shortcuts.png",
  "/placeholders/winslow_fun_fact.png",
];

export const APP_LOGOS = {
  // GOOGLE_API: "app_logos/google-docs-nobg.svg",
  GOOGLE_API: "/icon_google.png",
  FIGMA: "app_logos/figma-nobg.svg",
  MICROSOFT: "app_logos/microsoft.png",
  CONFLUENCE: "app_logos/confluence.png",
};

export const TAG_IMAGES = {
  PRIVATE: "tag_private.svg",
  RESTRICTED: "tag_restricted.svg",
  TEAM: "tag_team.svg",
  PUBLIC: "tag_public.svg",
};

export const EXTENSION_LANDING_IMAGE = "/extension_landing.svg";
